import { supabase } from "@/utils/supabase";
import { ClientMapper } from "@/adapters/Client.mapper";
export class ClientService {
    async getClientsWithParams(params) {
        try {
            let query = supabase()
                .from("clients")
                .select("*", { count: "exact" })
                .eq("isDeleted", false)
                .eq("isActive", true);
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [
                        `firstName.ilike.*${search}*`,
                        `lastName.ilike.*${search}*`,
                        `email.ilike.*${search}*`,
                        `phone.ilike.*${search}*`,
                    ];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("firstName", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(ClientMapper.toDomain),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getClientsWithParams:", error);
            throw error;
        }
    }
    async getClientsByIds(ids) {
        const { data, error } = await supabase()
            .from("clients")
            .select("*")
            .in("id", ids)
            .eq("isDeleted", false)
            .eq("isActive", true);
        if (error) {
            throw error;
        }
        return data.map(ClientMapper.toDomain);
    }
}
export const clientService = new ClientService();
